import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import moment from "moment";
import leftIcon from "../_assets/images/left_icon.png";
import infoIcon from "../_assets/images/info.png";
import { Button } from "../_components/button.component";
import Table from "../_components/table.component";
import { ToastTypes, withToast } from "../contexts/toastr.context";
import { Loader } from "../_components/loader.component";
import { MANAGE_COMMUNITY_ROUTE } from "./manage-community-group";
import { CommunityService } from "../_service/community-management.service";
import { ActionModal } from "../_components/action-modal.component";

export const ORGANIZATION_COMMUNITY_ROUTE = "/community";
export const ORG_COMMUNITY_ROUTE = (orgId) => "/community" + "?orgId=" + orgId;

export function getOrganizationCommunityRoute(orgId) {
  return "/community" + "?orgId=" + orgId;
}

function OrgCommunityPageComponent({ user, history, addToast, orgData }) {
  const [isLoading, setIsLoading] = useState(false);
  const [allGroups, setAllGroups] = useState([]);
  const [groupData, setGroupData] = useState({});
  const [isDeleteGroupModalVisible, setIsDeleteGroupModalVisible] =
    useState(false);
  const columns = React.useMemo(
    () => [
      {
        Header: "Group Names",
        accessor: "name",
        Cell: (data) => {
          return <div className="overflow-y-auto">{data.row.values.name}</div>;
        },
      },
      {
        Header: "Created",
        accessor: "created",
        // width: "45%",
        // maxWidth: "45%",
        Cell: (data) => {
          return <div>{moment(data.row.values.created).format("ll")}</div>;
        },
      },
      {
        Header: "Action",
        accessor: "_id",
        Cell: (data, index) => {
          return (
            <div className="flex items-center">
              <button
                onClick={() => handleShowGroupDetails(data.row.original)}
                className="w-1/5">
                <img src={infoIcon} alt="info" />
              </button>
              <button onClick={() => handleDeleteSupportGroup(data.row.values)}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6 text-primary"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}>
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                  />
                </svg>
              </button>
            </div>
          );
        },
      },
    ],
    []
  );

  const dispatch = useDispatch();
  const location = useLocation();
  const sp = new URLSearchParams(window.location.search);
  const orgId = sp.get("orgId");

  useEffect(() => {
    getOrganizationGroups(user, orgId);
  }, [orgId]);

  const getOrganizationGroups = (user, orgId) => {
    setIsLoading(true);
    CommunityService.getAllOrganizationGroups(user, orgId)
      .then((resp) => {
        setAllGroups(resp);
        setIsLoading(false);
        // dispatch(setOrganization({ organization: resp }));
      })
      .catch((error) => {
        setIsLoading(false);
        if (error && error.response && error.response.data.message) {
          addToast(error.response.data.message, "", ToastTypes.danger);
        }
      });
  };

  const handleShowGroupDetails = (data) => {
    history.push({
      pathname: `/manage-community-group/${orgId}/${data._id}`,
    });
  };

  const handleDeleteSupportGroup = (data) => {
    setIsDeleteGroupModalVisible(true);
    setGroupData(data);
  };

  const onSubmitDelete = () => {
    CommunityService.deleteGroup(user, groupData._id)
      .then((resp) => {
        addToast("Group deleted successfully", "", ToastTypes.success);
        const groupFilterData = allGroups.filter(
          (tr) => tr._id !== groupData._id
        );
        setIsDeleteGroupModalVisible(false);
        setGroupData({});
        setAllGroups(groupFilterData);
      })
      .catch((error) => {
        if (error && error.response && error.response.data.message) {
          addToast(error.response.data.message, "", ToastTypes.danger);
        }
      });
  };

  return (
    <div className="page-container ml-auto px-9 py-6">
      <div className="flex pb-4 back-btn-container items-center cursor-pointer">
        <img
          src={leftIcon}
          alt=""
          onClick={() => history.push("/community-management")}
        />
        <span
          className="ml-3 text-xl home-text t-grey"
          onClick={() => history.push("/community-management")}>
          Home
        </span>
      </div>
      <div className="flex flex-wrap">
        <div className="bg-white rounded-xl w-full px-11 py-9">
          <div>
            <div className="flex justify-between items-center">
              <p className="font-bold text-lg text-primary">
                Peer Support Group Management
              </p>
              <Button
                label="Create Group "
                onClick={() => history.push(MANAGE_COMMUNITY_ROUTE)}
                className="btn-primary"
              />
            </div>
          </div>
          {!isLoading ? (
            <div className="mt-5">
              {allGroups && allGroups.length > 0 ? (
                <>
                  <Table columns={columns} data={allGroups} />
                  <ActionModal
                    active={isDeleteGroupModalVisible}
                    setActive={setIsDeleteGroupModalVisible}
                    onSubmit={onSubmitDelete}
                    header="You are deleting Peer Support Group :"
                    userName={
                      groupData && groupData?.name ? groupData?.name : ""
                    }
                    title="Are you sure you want to delete the record?"
                    btnColor="red"
                  />
                </>
              ) : (
                <div>
                  <p className="text-primary">
                    Peer Support Groups data not found
                  </p>
                </div>
              )}
            </div>
          ) : (
            <Loader />
          )}
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  user: state.auth,
  orgData: state.orgData,
});

const OrgCommunityPage = withToast(
  connect(mapStateToProps)(OrgCommunityPageComponent)
);

export default OrgCommunityPage;
